'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.onPlay = onPlay;
exports.buildErrorLog = buildErrorLog;

var _baseState = require('./baseState');

var _baseState2 = _interopRequireDefault(_baseState);

var _tuner = require('../tuner');

var _tuner2 = _interopRequireDefault(_tuner);

var _listenTime = require('../loggers/listenTime');

var _listenTime2 = _interopRequireDefault(_listenTime);

var _debugger = require('../debugger');

var _debugger2 = _interopRequireDefault(_debugger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function onPlay() {
  _listenTime2.default.setReportStartTime();
  _tuner2.default.changeState(_tuner2.default.states.playing);
}

function buildErrorLog(error) {
  return {
    message: error.message,
    context: {
      error: error,
      streamId: _tuner2.default.streamPlayer.getCurrentStreamId()
    }
  };
}

var state = {
  name: 'failed',
  enter: function enter(previousState) {
    var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _debugger2.default.log('error', error);
    _listenTime2.default.stopPeriodicLogger();
    _tuner2.default.trigger(_tuner2.default.events.stationFailed, error.failedWithHttp);
    _tuner2.default.trigger(_tuner2.default.events.error, error instanceof Error ? buildErrorLog(error) : error);

    _tuner2.default.streamPlayer.on(_tuner2.default.streamPlayer.events.play, onPlay);
    // streamPlayer sometimes doesnt fire a play event when a stream resumes
    _tuner2.default.streamPlayer.on(_tuner2.default.streamPlayer.events.buffer, onPlay);
  },
  exit: function exit() {
    _tuner2.default.streamPlayer.remove(_tuner2.default.streamPlayer.events.play, onPlay);
    _tuner2.default.streamPlayer.remove(_tuner2.default.streamPlayer.events.buffer, onPlay);
  }
};

exports.default = (0, _extends3.default)({}, _baseState2.default, state);
//# sourceMappingURL=failed.js.map